export default "__VITE_ASSET__CeJDQEYC__"